export enum AsideSize {
    ICON = 23,
}
export enum LoginStatus {
    Fail = 'Unauthorized',
}

export enum Rate {
    USD = 25000,
}
